import { Globe02 } from "@untitledui/icons"

/**
 * The "visible on class website" notice at a public card's bottom, below its comments.
 * Every card type renders this one component, so the notice can't drift between them.
 *
 * Globe02 is the same icon the card menu's "Show Card on Class Website" row uses — the notice is
 * that toggle's result, so they read as one thing.
 */
export const CardPublicNotice = () => (
  // -mx-3/px-3 makes it full-bleed like the rest of the card.
  <div
    className="-mx-3 flex items-center gap-1 px-3 pt-2 text-xs text-card-muted select-none selection:bg-transparent"
    contentEditable={false}
  >
    <Globe02 className="size-3.5 shrink-0" />
    Visible on class website
  </div>
)
